import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { TextField } from '@mui/material';
import { Control, Controller, FieldErrors, FieldValues } from 'react-hook-form';
import { isValid } from 'date-fns';
import { clearSeconds } from '@dispatch/shared';

export const DateTimeField = function ({
  id,
  name,
  label,
  control,
  onChange,
  errors,
  required,
  readOnly,
  disabled,
}: {
  id: string;
  name: string;
  label: string;
  control: Control<FieldValues>;
  onChange?: (values: string) => void;
  errors?: FieldErrors;
  required?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
}) {
  return (
    <Controller
      rules={{ required: true }}
      control={control}
      name={name}
      render={({ field: { onChange: dateChange, value } }) => {
        return (
          <MobileDateTimePicker
            onChange={(date) => {
              if (date && isValid(date)) {
                const [dateSanitzed] = clearSeconds(date);

                dateChange(dateSanitzed?.toISOString());
              }
            }}
            onAccept={(date) => {
              if (date && isValid(date)) {
                const [dateSanitzed] = clearSeconds(date);
                onChange?.(dateSanitzed?.toISOString());
              }
            }}
            renderInput={(props) => (
              <TextField
                {...props}
                sx={{ width: '100%' }}
                id={id}
                variant="standard"
                error={!!errors && !!errors[id]?.message}
                helperText={!!errors && errors[id]?.message}
                required={required}
              />
            )}
            label={label}
            value={new Date(value)}
            readOnly={readOnly}
            disabled={disabled}
          />
        );
      }}
    />
  );
};
